import { Platform, StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { Background } from 'src/theme-v2/background';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Neutrals } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const stylesDesktop = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: -5,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 8,
    width: '100%',
    gap: 10,
    zIndex: 2,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
  },

  hoverTextContainer: {
    position: 'absolute',
    bottom: 20, // Posizionato sopra l'icona
    backgroundColor: Background.BackgroundColorDefault,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: Neutrals.main.Black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  selectButton: {
    position: 'relative',
    zIndex: 3,
    borderRadius: 20,
    padding: 6,

    width: 32,
    height: 32,

    justifyContent: 'center',
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      color: '#000000',
      opacity: 0.05,
    }),
    backgroundColor: Background.BackgroundColorDefault,
  },
  dropdownContainer: {
    position: 'absolute',
    zIndex: 2,
    top: 24,
  },
  dropdownLookupContainer: {
    position: 'absolute',
    top: 24,
    left: 32,
    backgroundColor: Background.BackgroundColorDefault,
    borderRadius: 13,
    paddingVertical: 16,
    minWidth: 145,
    zIndex: 1,
    ...Platform.select({
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 43,
      },
      default: {
        elevation: 8,
      },
    }),
  },
  scrollViewVertical: {
    flex: 1,
    maxHeight: 300,
  },
  sectionWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: 8,
    flexWrap: 'wrap',
  },
  paperButton: {
    position: 'relative',
    zIndex: 2,
    justifyContent: 'center',
    height: 32,
    paddingHorizontal: Spacing.Tight,
    borderRadius: CornerRadius.Full,
    backgroundColor: Neutrals.main.White,
    ...getBoxShadow({
      offsetX: 0,
      offsetY: 4,
      blurRadius: 10,
      spreadRadius: 0,
      opacity: 0.05,
      color: Neutrals.main.Black,
    }),
  },
  paperText: {
    ...textLatoStyleDS.BodyBoldXs,
    color: ColorTypography.TextColorInteractive,
  },
});

export const stylesMobile = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: -5,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 8,
    width: '100%',
    gap: 10,
    zIndex: 2,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 20, // Posizionato sopra l'icona
    backgroundColor: Background.BackgroundColorDefault,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: Neutrals.main.Black,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  selectButton: {
    position: 'relative',
    zIndex: 6,
    borderRadius: 10,
    padding: 8,
    backgroundColor: Background.BackgroundColorDefault,
  },
  dropdownContainer: {
    position: 'absolute',
    zIndex: 5,
    top: 24,
  },
  dropdownLookupContainer: {
    position: 'absolute',
    top: 24,
    left: 32,
    backgroundColor: Background.BackgroundColorDefault,
    borderRadius: 13,
    paddingVertical: 16,
    minWidth: 145,
    zIndex: 1,
    ...Platform.select({
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 43,
      },
      default: {
        elevation: 8,
      },
    }),
  },
  scrollViewVertical: {
    flex: 1,
    maxHeight: 300,
  },

  sectionWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: 8,
    flexWrap: 'wrap',
  },
  paperButton: {
    position: 'relative',
    zIndex: 2,
    justifyContent: 'center',
    height: 34,
    paddingHorizontal: Spacing.Cozy,
    borderRadius: CornerRadius.Full,
    backgroundColor: Background.BackgroundColorDefault,
  },
  paperText: {
    ...textLatoStyleDS.BodyBoldXs,
    color: ColorTypography.TextColorInteractive,
  },
});
